export default __webpack_public_path__ + "static/media/piggy-bank.7584a77d.svg";